<template>
  <button class="wf-component wf-yah" @click="onClicked()">
    <i class="wf-icon"/>
    <label v-if="showLabel" data-translation-element="yah">YAH</label>
  </button>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapState('wf', ['language'])
  },
  methods: {
    onClicked () {
      this.$wayfinder.showKiosk();
      this.$store.dispatch('setCurrentPage', 'flights');
      this.$store.dispatch('setSchengenZone', 'nonschengen');
      this.$store.dispatch('setPOI', null);
      this.$store.dispatch('setFlightDirection', 'departures');
      setTimeout(() => {
        this.$store.dispatch('setCurrentPage', 'grouppois');
        this.$store.dispatch('setSchengenZone', 'schengen');
      }, 50);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wf-yah {
  text-align: center;
  border: none;
  outline: none;
}

.wf-icon {
  width: 100%;
  height: 100%;
  display: block;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NzYgNTEyIj48IS0tIUZvbnQgQXdlc29tZSBGcmVlIDYuNi4wIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlL2ZyZWUgQ29weXJpZ2h0IDIwMjQgRm9udGljb25zLCBJbmMuLS0+PHBhdGggZD0iTTU3NS44IDI1NS41YzAgMTgtMTUgMzIuMS0zMiAzMi4xbC0zMiAwIC43IDE2MC4yYzAgMi43LS4yIDUuNC0uNSA4LjFsMCAxNi4yYzAgMjIuMS0xNy45IDQwLTQwIDQwbC0xNiAwYy0xLjEgMC0yLjIgMC0zLjMtLjFjLTEuNCAuMS0yLjggLjEtNC4yIC4xTDQxNiA1MTJsLTI0IDBjLTIyLjEgMC00MC0xNy45LTQwLTQwbDAtMjQgMC02NGMwLTE3LjctMTQuMy0zMi0zMi0zMmwtNjQgMGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJsMCA2NCAwIDI0YzAgMjIuMS0xNy45IDQwLTQwIDQwbC0yNCAwLTMxLjkgMGMtMS41IDAtMy0uMS00LjUtLjJjLTEuMiAuMS0yLjQgLjItMy42IC4ybC0xNiAwYy0yMi4xIDAtNDAtMTcuOS00MC00MGwwLTExMmMwLS45IDAtMS45IC4xLTIuOGwwLTY5LjctMzIgMGMtMTggMC0zMi0xNC0zMi0zMi4xYzAtOSAzLTE3IDEwLTI0TDI2Ni40IDhjNy03IDE1LTggMjItOHMxNSAyIDIxIDdMNTY0LjggMjMxLjVjOCA3IDEyIDE1IDExIDI0eiIvPjwvc3ZnPg==");
}
</style>
